import Vue from 'vue'
import Router from 'vue-router'
import DefaultRouter from './default'
import MainRouter from './main'

import { getWechatPublicAuthorizationUrl,wechatH5AuthLogin,getLoginStatus } from '@/api/login'


Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let router = new Router({
  mode: 'history',
  routes: [
    ...DefaultRouter,
    ...MainRouter
  ]
})

/** 检测是否是微信环境 */
const isWeChat = () => {
  const ua = navigator.userAgent.toLowerCase();
  let arr = ua.match(/MicroMessenger/i) || []
  return arr.includes("micromessenger")
}
router.beforeEach(async (to, from, next) => {



  const whiteList = ['/q', '/ql', '/weChatPublicMsgLink']
  const flag =  whiteList.some(el => to.path.includes(el))
  const isExist = document.getElementById('referrer')

  if(flag) {
    if(!isExist) {
      const meta = document.createElement('meta')
      meta.setAttribute('name', 'referrer')
      meta.setAttribute('content', 'no-referrer')
      meta.setAttribute('id', 'referrer')
      document.head.appendChild(meta)
    }
  } else {
    document.title = to.meta.title
    if(isExist) {
      document.head.removeChild(isExist)
    }
  }
    /**判断是否微信环境 */
  if(!isWeChat()) {
    next()
    return
  }

  /** 判断token是否失效 */
  const token =  localStorage.getItem('token') || ''
  if(token) {
    const loginInfo =  await getLoginStatus()
    console.log(loginInfo, 'loginInfo------------')
    /*if(to.name == 'land' ||to.name == 'weChatPublicMsgLink' ) {
      const str = localStorage.getItem('dataInfo')
      if(str) {
        const info = JSON.parse(str)
        document.title = info.pageTitle || '\u200b'
      }
    }*/
    if(loginInfo.mdata.loginStatus == 0) {
      localStorage.removeItem('token')
     }
  }


  const {protocol, pathname} = window.location
      //防止需要进行二次授权的时候把参数带进去
    const params = {
      // 协议类型，0代表“http”，1代表“https”
      agreement: Number(protocol.includes('https')),
      route: pathname,
      //url类型，0代表静默授权，1代表非静默授权
      authorizationType: 0,
      extraParam: to.query,
    }
    // 进入详情页 且 是返利 且 没有登录 并且不是授权回来的
  if(to.name == 'goodDetail' && to.query.type == 1 && !token && !to.query.code) {
    console.log(to.query.code, 'to.query.code-----')
    /** 获取静默授权的url */
    const res = await getWechatPublicAuthorizationUrl(params)
    localStorage.setItem('authorizationType', 0)
    window.location.href = res.mdata.authorizationUrl
  } else {
    next()
  }


})
export default router
